// Close on a screen (Josh 10-02, on his phone: "how do I close a session?"). Snap shows one window at a time with no
// window bar of its own, so the page's top bar — which already names the window in front — carries its ×: a small
// mark with a full 44 px touch (core/screen-phone.css), right before ⋯; and ⋯ › Close “…” says the same in words.
// Close means what it means on the headset: the window goes, nothing else — a session's window closes and the
// session stays on Home (app.js closeWindow); a stream stops. Home itself is never closed. In Look, the window
// brought up (or the one in front) is the one closed.
//
// One seam: `screenClose(world)` → `{ update() }`; render-dom.js calls update whenever the window in front changes.

const X = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>'

export function screenClose(world) {
  const more = document.getElementById('more'), sheet = document.getElementById('sheet')
  if (!more || document.getElementById('close-window')) return { update() {} }
  const x = document.createElement('button')
  x.id = 'close-window'
  x.hidden = true
  x.innerHTML = X
  more.before(x)
  const row = document.createElement('button')
  row.id = 'sheet-close'
  row.className = 'link'
  row.hidden = true
  const modes = document.getElementById('sheet-modes')
  if (modes) modes.after(row); else sheet?.prepend(row)

  // on a phone a sheet in front (core/screen-sheets.js) is what closes; otherwise the window in front
  const target = () => world.sheets?.top() || (world.mode === 'snap' ? world.current : world.zoomed || world.current)
  const closable = (s) => !!s && s.closable === true && s.id !== 'home' && !!world.app.closeWindow
  const close = () => {
    const s = target()
    if (sheet) sheet.hidden = true
    if (closable(s)) world.app.closeWindow(s)
  }
  x.addEventListener('click', close)
  row.addEventListener('click', close)
  return {
    update() {
      const s = target(), on = !world.suspended && closable(s)
      x.hidden = !on; row.hidden = !on
      const name = on ? (s.short || s.name || 'window') : ''
      x.setAttribute('aria-label', on ? `Close ${name}` : 'Close window')
      x.title = on ? `Close ${name}` : ''
      row.textContent = on ? `Close “${name}”` : ''
    },
  }
}
